/**
 * UK Airport Codes
 * List of all UK airports that require transit visa notification
 * Format: Airport Code - Full Airport Name
 */

export const UK_AIRPORTS = [
  "LHR", // London Heathrow
  "LGW", // London Gatwick
  "STN", // London Stansted
  "LTN", // London Luton
  "LCY", // London City
  "MAN", // Manchester
  "EDI", // Edinburgh
  "BHX", // Birmingham
  "GLA", // Glasgow
  "BFS", // Belfast International
  "BHD", // George Best Belfast City
  "NCL", // Newcastle
  "LPL", // Liverpool John Lennon
  "LBA", // Leeds Bradford
  "EMA", // East Midlands
  "ABZ", // Aberdeen
  "BRS", // Bristol
  "SOU", // Southampton
  "CWL", // Cardiff
  "INV", // Inverness
  "EXT", // Exeter
  "NWI", // Norwich
  "NQY", // Newquay Cornwall
  "BRR", // Barra
  "BEB", // Benbecula
  "CAL", // Campbeltown
  "LDY", // Derry
  "DND", // Dundee
  "MME", // Durham Tees Valley
  "FIE", // Fair Isle
  "FOA", // Foula
  "ILY", // Islay
  "KOI", // Kirkwall
  "LEQ", // Land's End
  "OBN", // Oban
  "PPW", // Papa Westray
  "SYY", // Stornoway
  "TRE", // Tiree
  "WIC", // Wick
  "ISC", // Isles of Scilly – St Mary's
  "TSO", // Tresco
];
